import {DateTimePicker, DateTimePickerProps, DateValue} from "@mantine/dates";
import {forwardRef} from "react";
import {Box, BoxProps, Group, Tooltip} from "@mantine/core";
import dayjs, {Dayjs} from "dayjs";
import {IconClock, IconInfoCircle} from "@tabler/icons-react";
import classes from "./NaiveDateTimePicker.module.css";

interface NaiveDateTimePickerProps extends BoxProps {
    value: Dayjs | undefined
    onChange: (value: Dayjs) => void
    label?: string
    description?: string
    dateTimeProps?: Exclude<DateTimePickerProps, "value" | "onChange"> & { "data-testid"?: string }
    readonly?: boolean
}

export const NaiveDateTimePicker = forwardRef<HTMLDivElement, NaiveDateTimePickerProps>(
    ({value, onChange, label, description, dateTimeProps, readonly = false, ...others}, ref) => {
        const dateValue = value?.toDate();

        const onSetTime = (dt: DateValue) => {
            if (!dt) {
                return;
            }
            try {
                onChange(dayjs(dt));
            } catch (ex) {
                console.error(ex);
            }
        };

        return (
            <Box ref={ref} {...others}>
                <DateTimePicker
                    data-testid="input-datetime"
                    label={
                        label && (
                            <Group gap={4} wrap="nowrap">
                                {label}
                                {description && (
                                    <Tooltip label={description} multiline maw={280} withArrow>
                                        <IconInfoCircle size={14} style={{cursor: "help", flexShrink: 0}}/>
                                    </Tooltip>
                                )}
                            </Group>
                        )
                    }
                    required={true}
                    value={dateValue}
                    withSeconds
                    disabled={readonly}
                    onChange={onSetTime}
                    timeInputProps={{"aria-label": "time-input"}}
                    rightSection={
                        readonly ? <></> :
                            <Tooltip label={"Set time to now."}>
                                <Box style={{
                                    display: "grid",
                                    grid: "auto/auto",
                                    alignItems: "center",
                                    cursor: "pointer",
                                }}>
                                    <IconClock className={classes.now} onClick={() => onSetTime(dayjs().toDate())}/>
                                </Box>
                            </Tooltip>
                    }
                    {...dateTimeProps}
                />
            </Box>
        );
    },
);

